import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ResendCooldownService {
  private readonly COOLDOWN = 60;
  private timestamps = new Map<string, number>();

  markSent(email: string): void {
    this.timestamps.set(email, Date.now());
    setTimeout(() => this.timestamps.delete(email), this.COOLDOWN * 1000);
  }

  getRemaining(email: string): number {
    const ts = this.timestamps.get(email);
    if (!ts) return 0;
    const elapsed = Math.floor((Date.now() - ts) / 1000);
    const remaining = this.COOLDOWN - elapsed;
    if (remaining <= 0) {
      this.timestamps.delete(email);
      return 0;
    }
    return remaining;
  }

  updateFromError(email: string, message: string): number {
    const match = message.match(/(\d+)\s*(second|секунд|վայրկ)/i);
    if (!match) return 0;
    const seconds = parseInt(match[1], 10);
    this.timestamps.set(email, Date.now() - (this.COOLDOWN - seconds) * 1000);
    setTimeout(() => this.timestamps.delete(email), seconds * 1000);
    return seconds;
  }
}
